import React, { useState } from 'react';
import './Page.css';

const Apply = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    program: '',
    experience: '',
    currentRole: '',
    motivation: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here
    alert('Thank you for your application! We will review it and get back to you within 24-48 hours.');
    setFormData({
      name: '',
      email: '',
      phone: '',
      program: '',
      experience: '',
      currentRole: '',
      motivation: ''
    });
  };

  return (
    <div className="page">
      <section className="page-hero apply-hero page-hero--red">
        <div className="container">
          <div className="hero-content-wrapper">
            <h1>Start Your Data Career Journey</h1>
            <p className="hero-subtitle">
              Apply for our upcoming batch and join a community of learners building careers in Data, Analytics & AI
            </p>
          </div>
        </div>
      </section>

      <section className="page-content section">
        <div className="container">
          <div className="apply-wrapper">
            <div className="apply-info">
              <h2>Why Apply Now?</h2>
              <div className="info-cards">
                <div className="info-card">
                  <div className="info-icon">🎯</div>
                  <h3>Limited Seats</h3>
                  <p>Small batch sizes ensure personalized attention</p>
                </div>
                <div className="info-card">
                  <div className="info-icon">📅</div>
                  <h3>Upcoming Batch</h3>
                  <p>Early applicants get priority enrollment</p>
                </div>
                <div className="info-card">
                  <div className="info-icon">💼</div>
                  <h3>Career Support</h3>
                  <p>Comprehensive guidance from day one</p>
                </div>
              </div>
            </div>

            <div className="apply-form-wrapper">
              <div className="form-header">
                <h2>Application Form</h2>
                <p>Fill in your details and we'll get back to you soon</p>
              </div>
              <form className="apply-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name">Full Name *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="Enter your full name"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email Address *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="your.email@example.com"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="phone">Phone Number *</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    placeholder="+91 XXXXX XXXXX"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="program">Program of Interest *</label>
                  <select
                    id="program"
                    name="program"
                    value={formData.program}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select a program</option>
                    <option value="data-analytics">Data Analytics</option>
                    <option value="data-engineering">Data Engineering</option>
                    <option value="data-science-ai">Data Science & AI</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="experience">Years of Experience</label>
                  <select
                    id="experience"
                    name="experience"
                    value={formData.experience}
                    onChange={handleChange}
                  >
                    <option value="">Select experience level</option>
                    <option value="fresher">Fresher / Student</option>
                    <option value="0-2">0-2 years</option>
                    <option value="2-5">2-5 years</option>
                    <option value="5+">5+ years</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="currentRole">Current Role / Background</label>
                  <input
                    type="text"
                    id="currentRole"
                    name="currentRole"
                    value={formData.currentRole}
                    onChange={handleChange}
                    placeholder="e.g., Software Engineer, Student, Analyst"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="motivation">Why do you want to join this program? *</label>
                  <textarea
                    id="motivation"
                    name="motivation"
                    rows="5"
                    value={formData.motivation}
                    onChange={handleChange}
                    required
                    placeholder="Tell us about your goals and motivation..."
                  ></textarea>
                </div>

                <button type="submit" className="btn btn-primary btn-large">
                  Submit Application
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Apply;



